import React, { useState } from 'react';

export default function FAQAccordion({ items }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!items || items.length === 0) return null;

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6 max-w-6xl mx-auto items-start">
      {items.map((item, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={item.id || idx}
            className="rounded-2xl border border-[#E8DFD5] bg-white overflow-hidden transition-all duration-200 shadow-xs"
          >
            <button
              type="button"
              onClick={() => toggle(idx)}
              className="w-full text-left p-6 flex items-center justify-between gap-4 font-serif text-xl font-medium text-[#2E2A27] cursor-pointer hover:text-[#98866C] transition-colors"
              aria-expanded={isOpen}
            >
              <span>{item.sporgsmal}</span>
              <span className={`w-8 h-8 rounded-full bg-[#FAF7F2] flex items-center justify-center text-[#2E2A27] transition-transform duration-300 ${isOpen ? 'rotate-180 bg-[#98866C] text-white' : 'bg-[#FAF7F2] text-[#2E2A27]'}`}>
                <i className="fa-solid fa-chevron-down text-sm" aria-hidden="true" />
              </span>
            </button>

            {isOpen && (
              <div className="px-6 pb-6 pt-1 text-[#5C524A] text-base leading-relaxed border-t border-[#F7F2EB] animate-fade-in">
                <p>{item.svar}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
